// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Core from "@material-ui/core";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as App_Table$DvmAdminFrontendFr from "../../../common/components/table/App_Table.bs.js";
import * as Utils_Api$DvmAdminFrontendFr from "../../../common/utils/Utils_Api.bs.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../intl/Intl_Utils.bs.js";
import * as App_Table_Head$DvmAdminFrontendFr from "../../../common/components/table/App_Table_Head.bs.js";
import * as App_Table_Types$DvmAdminFrontendFr from "../../../common/components/table/App_Table_Types.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../intl/messages/Messages_Common.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../common/types/App_Types_Result.bs.js";
import * as App_Table_Pagination$DvmAdminFrontendFr from "../../../common/components/table/App_Table_Pagination.bs.js";
import * as Company_Search_Types$DvmAdminFrontendFr from "./Company_Search_Types.bs.js";
import * as App_Table_Export_Menu$DvmAdminFrontendFr from "../../../common/components/table/App_Table_Export_Menu.bs.js";

var headersConfiguration_0 = App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Company_Search_Types$DvmAdminFrontendFr.Fields.siret, undefined, false, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.siret);

var headersConfiguration_1 = {
  hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Company_Search_Types$DvmAdminFrontendFr.Fields.siren, undefined, false, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.siren),
  tl: {
    hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Company_Search_Types$DvmAdminFrontendFr.Fields.siretName, undefined, false, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.companyName),
    tl: {
      hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Company_Search_Types$DvmAdminFrontendFr.Fields.city, undefined, false, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.city),
      tl: {
        hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Company_Search_Types$DvmAdminFrontendFr.Fields.endDate, undefined, false, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.endDate),
        tl: /* [] */0
      }
    }
  }
};

var headersConfiguration = {
  hd: headersConfiguration_0,
  tl: headersConfiguration_1
};

function Company_Search_Table(Props) {
  var tablePage = Props.tablePage;
  var fetchRequest = Props.fetchRequest;
  var fetchData = Props.fetchData;
  var intl = ReactIntl.useIntl();
  var convertTable = function (table) {
    return App_Types_Result$DvmAdminFrontendFr.map(table, (function (param) {
                  return {
                          content: Belt_List.map(param.content, (function (row) {
                                  return App_Table_Types$DvmAdminFrontendFr.makeRow((function (param) {
                                                RescriptReactRouter.push("company/" + row.siret);
                                              }), undefined, undefined, Belt_List.mapWithIndex({
                                                  hd: row.siret,
                                                  tl: {
                                                    hd: Belt_Option.getWithDefault(row.siren, ""),
                                                    tl: {
                                                      hd: Belt_Option.getWithDefault(row.siretName, ""),
                                                      tl: {
                                                        hd: Belt_Option.mapWithDefault(row.city, "", (function (x) {
                                                                return x;
                                                              })),
                                                        tl: {
                                                          hd: Belt_Option.mapWithDefault(row.endDate, "", (function (param) {
                                                                  return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                                                })),
                                                          tl: /* [] */0
                                                        }
                                                      }
                                                    }
                                                  }
                                                }, (function (index, content) {
                                                    return App_Table$DvmAdminFrontendFr.makeCell(Belt_Option.map(Belt_List.get(headersConfiguration, index), (function (param) {
                                                                      return param.align;
                                                                    })), undefined, undefined, content);
                                                  })));
                                })),
                          currentPage: fetchRequest.page,
                          totalElements: param.total
                        };
                }));
  };
  var handleSorting = function (headers) {
    Curry._2(fetchData, undefined, {
          page: fetchRequest.page,
          rowsPerPage: fetchRequest.rowsPerPage,
          headers: headers,
          filterQueryParams: fetchRequest.filterQueryParams,
          additionalQueryParams: fetchRequest.additionalQueryParams
        });
  };
  var handleChangePage = function (page) {
    Curry._2(fetchData, undefined, {
          page: page,
          rowsPerPage: fetchRequest.rowsPerPage,
          headers: fetchRequest.headers,
          filterQueryParams: fetchRequest.filterQueryParams,
          additionalQueryParams: fetchRequest.additionalQueryParams
        });
  };
  var handleRowsPerPageChange = function (rowsPerPage) {
    Curry._2(fetchData, undefined, {
          page: 0,
          rowsPerPage: rowsPerPage,
          headers: fetchRequest.headers,
          filterQueryParams: fetchRequest.filterQueryParams,
          additionalQueryParams: fetchRequest.additionalQueryParams
        });
  };
  var tmp;
  tmp = typeof tablePage === "number" || tablePage.TAG !== /* Ok */0 ? true : tablePage._0.total > 30000;
  return React.createElement(React.Fragment, undefined, React.createElement(App_Table$DvmAdminFrontendFr.make, {
                  headers: fetchRequest.headers,
                  handleSorting: handleSorting,
                  tablePage: convertTable(tablePage),
                  paginator: App_Table_Pagination$DvmAdminFrontendFr.makePaginator(undefined, undefined, handleChangePage, handleRowsPerPageChange, undefined),
                  exportMenu: React.createElement(Core.Tooltip, {
                        arrow: true,
                        children: React.createElement("div", undefined, React.createElement(App_Table_Export_Menu$DvmAdminFrontendFr.make, {
                                  query: Utils_Api$DvmAdminFrontendFr.createQueryParams(undefined, {
                                        page: 0,
                                        rowsPerPage: 30000,
                                        headers: fetchRequest.headers,
                                        filterQueryParams: fetchRequest.filterQueryParams,
                                        additionalQueryParams: fetchRequest.additionalQueryParams
                                      }),
                                  endpoint: "sirets",
                                  disabled: tmp
                                })),
                        placement: "top",
                        title: intl.formatMessage(Messages_Common$DvmAdminFrontendFr.maxLinesExport, {
                              count: "30 000"
                            })
                      })
                }));
}

var Api;

var make = Company_Search_Table;

export {
  Api ,
  headersConfiguration ,
  make ,
}
/* headersConfiguration Not a pure module */
